/**
 * Home V2 工作中任务的 FTO 报告导出服务。
 */
export interface WorkInProgressFtoExportService {
    /**
     * 为指定 FTO 任务创建一份新报告，等待生成完成后导出 Word。
     *
     * @param taskId FTO 任务 ID。
     * @returns 新报告的下载地址。
     */
    exportReport(taskId: string): Promise<string>;
}

/**
 * Home V2 工作中任务 FTO 报告导出服务的依赖注入标识。
 */
export const WorkInProgressFtoExportService = Symbol('WorkInProgressFtoExportService');
